import translate from '@i18n'
import { reactionMapping } from './constants'
import {
  CommentAuthorType,
  OwnReactionValues,
  Reaction,
  Reactions,
} from './types'

const createHasOwnReaction =
  (commentId: number, reactions: Reactions) =>
  (reaction: Reaction): boolean =>
    reactions[commentId] === reaction

export const getOwnReactionValues = (
  commentId: number,
  reactions?: Reactions
): OwnReactionValues => {
  const hasOwnReaction = reactions
    ? createHasOwnReaction(commentId, reactions)
    : () => false
  return {
    heart: hasOwnReaction(reactionMapping.heart),
    bolt: hasOwnReaction(reactionMapping.bolt),
    happy: hasOwnReaction(reactionMapping.happy),
    sad: hasOwnReaction(reactionMapping.sad),
    critical: hasOwnReaction(reactionMapping.critical),
  }
}

export const getTitle = ({
  name = '',
  statusId = 0,
}: {
  name: string
  statusId?: number
  authorType?: CommentAuthorType
}) => (statusId === 3 ? translate('commenting.deletedUserName') : name)

export const charactersLeftText = (numberOfChars: number) => {
  let label = ''
  if (numberOfChars < 0) {
    label =
      numberOfChars === -1
        ? translate('commenting.oneCharacterOverflow', {
            numberOfCharacters: Math.abs(numberOfChars).toString(),
          })
        : translate('commenting.numberOfCharactersOverflow', {
            numberOfCharacters: Math.abs(numberOfChars).toString(),
          })
  } else {
    label =
      numberOfChars === 1
        ? translate('commenting.oneCharacterLeft', {
            numberOfCharacters: numberOfChars.toString(),
          })
        : translate('commenting.numberOfCharactersLeft', {
            numberOfCharacters: numberOfChars.toString(),
          })
  }
  return label
}
